import { RouterOptions } from "vite-ssg"

export const routerOptions: RouterOptions = {
    routes: [
        {
            name: "concept",
            path: "/",
            component: () => import("~/pages/concept/Concept.vue")
        },
        {
            name: "terms-of-use",
            path: "/terms-of-use",
            component: () => import("~/pages/terms-of-use/TermsOfUse.vue")
        },
        {
            name: "privacy-policy",
            path: "/privacy-policy",
            component: () => import("~/pages/privacy-policy/PrivacyPolicy.vue")
        },
        {
            name: "accessibility-statement",
            path: "/accessibility-statement",
            component: () => import("~/pages/accessibility-statement/AccessibilityStatement.vue")
        },
        {
            name: "reservations",
            path: "/reservations",
            redirect: to => ({
                name: "concept",
                query: { ...to.query, modal: "reservations" }
            })
        },
        {
            name: "home",
            path: "/:name",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: null 
            }
        },
        {
            name: "home-menus",
            path: "/:name/menus/:category?",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#menus",
                section: "menus",
                title: "Menus"
            }
        },
        {
            name: "home-large-party",
            path: "/:name/large-party-reservations",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#large-party-reservations",
                section: "large-party-reservations",
                title: "Large Party Reservations"
            }
        },
        {
            name: "home-private-dining",
            path: "/:name/private-dining",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#private-dining",
                section: "private-dining",
                title: "Private Dining"
            }
        },
        {
            name: "home-catering",
            path: "/:name/catering",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#catering",
                section: "catering",
                title: "Catering"
            }
        },
        {
            name: "home-merch",
            path: "/:name/merch",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#merch",
                section: "merch",
                title: "Merch"
            }
        },
        {
            name: "home-hours-location",
            path: "/:name/hours-location",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#hours-location",
                section: "hours-location",
                title: "Hours & Location"
            }
        },
        {
            name: "home-gift-cards",
            path: "/:name/gift-cards-rewards",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#gift-cards-rewards",
                section: "gift-cards-rewards",
                title: "Gift Cards & Rewards"
            }
        },
        {
            name: "home-faq",
            path: "/:name/faq",
            component: () => import("~/pages/location/Location.vue"),
            meta: { 
                location: true,
                scrollTo: "#faq",
                section: "faq",
                title: "FAQs"
            }
        },
        {
            name: "home-contact",
            path: "/:name/contact",
            component: () => import("~/pages/location/Location.vue"),
            meta: {
                location: true,
                scrollTo: null,
                section: "contact",
                title: "Contact Us"
            }
        },
        {
            name: "home-reservations",
            path: "/:name/reservations",
            redirect: to => ({
                name: "home",
                params: { ...to.params },
                query: { ...to.query, modal: "reservations" }
            })
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: { name: "concept" }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        
        if (to.meta.scrollTo) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({
                        el: to.meta.scrollTo as string,
                        behavior: "smooth"
                    })
                }, 100)
            })
        }
        
        if (to.hash) {
            return {
                el: to.hash,
                behavior: "smooth",
                top: 120
            }
        }
        
        if (!from.name || from.params.name !== to.params.name) {
            return { 
                top: 0, 
                left: 0,
                behavior: "smooth"
            }
        }
        
        return { top: 0, left: 0 }
    }
}